<template>
  <ul :class="brandClasses.list">
    <li v-for="{ label, thumbnail } of data" :key="label" :class="brandClasses.listItem">
      <base-button :class="brandClasses.button" @click="DialogProductDetailCard.open({ data, title })">
        <base-picture
          v-if="thumbnail"
          :alt="label"
          :class="brandClasses.picture"
          fit="contain"
          height="64"
          :src="thumbnail"
          width="64"
        />
        <span v-if="label" class="line-clamp-2 break-words">
          {{ label }}
        </span>
      </base-button>
    </li>
    <dialog-product-detail-card size="sm" />
  </ul>
</template>

<script setup lang="ts">
import type { ProductDetailContent } from '#types/product'

defineProps<{
  data: ProductDetailContent[]
  title: string
}>()

const { brandClasses, dialogOptions } = useAppConfig().components.product.accordions.modalGrid

const DialogProductDetailCard = createDialog('product-detail-card', dialogOptions)
</script>
